export const ADDP_CURRENCIES = ['USD', 'EUR', 'GBP', 'JPY'] as const;
export type AddpCurrency = typeof ADDP_CURRENCIES[number];
